<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            {{ snackbar_msg }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- CHART 1: Current Month Usage Analysis (Loads immediately) -->
        <v-card flat class="pa-4 mt-4">
            <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                Current Month Usage Analysis
            </v-card-title>
            <v-skeleton-loader v-if="loading1" type="image" class="mx-auto" style="max-width: 900px; height: 500px;" />
            <chart v-else ref="chart1" class="chart" auto-resize :options="usageChart" />
        </v-card>

        <!-- CHART 2: Last 6 Months Usage Analysis -->
        <lazy-observer :onVisible="loadSixMonths">
            <template v-slot:default>
                <v-card flat class="pa-4 mt-10">
                    <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                        Last Six Months Usage Analysis
                    </v-card-title>
                    <v-skeleton-loader v-if="loading2" type="image" class="mx-auto"
                        style="max-width: 900px; height: 550px;" />
                    <chart v-else ref="chart2" class="chart" auto-resize :options="sixMonthsChart" />
                </v-card>
            </template>
        </lazy-observer>

        <!-- CHART 3: Module Usage Pie Chart -->
        <lazy-observer :onVisible="loadModuleUsage">
            <template v-slot:default>
                <v-card flat class="pa-4 mt-10">
                    <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                        Module Usage Analysis
                    </v-card-title>
                    <v-skeleton-loader v-if="loading3" type="image" class="mx-auto"
                        style="max-width: 600px; height: 500px;" />
                    <chart v-else ref="chart3" class="chart-pie" auto-resize :options="moduleChart" />
                </v-card>
            </template>
        </lazy-observer>

        <!-- CHART 4: Certificate Issuance Count -->
        <lazy-observer :onVisible="loadCertificateCount">
            <template v-slot:default>
                <v-card flat class="pa-4 mt-10">
                    <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                        Certificate Issuance Count
                    </v-card-title>
                    <v-skeleton-loader v-if="loading4" type="image" class="mx-auto"
                        style="max-width: 800px; height: 500px;" />
                    <chart v-else ref="chart4" class="chart-bar" auto-resize :options="certificateChart" />
                </v-card>
            </template>
        </lazy-observer>

        <!-- CHART 5: Cumulative Certificate Issuance -->
        <lazy-observer :onVisible="loadCumulativeCertificate">
            <template v-slot:default>
                <v-card flat class="pa-4 mt-10">
                    <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                        Certificate Issuance - Cumulative
                    </v-card-title>
                    <v-skeleton-loader v-if="loading5" type="image" class="mx-auto"
                        style="max-width: 900px; height: 500px;" />
                    <chart v-else ref="chart5" class="chart-line" auto-resize :options="cumulativeChart" />
                </v-card>
            </template>
        </lazy-observer>

        <!-- CHART 6: Online Admission Cumulative -->
        <lazy-observer :onVisible="loadOnlineAdmissionCumulative">
            <template v-slot:default>
                <v-card flat class="pa-4 mt-10">
                    <v-card-title class="text-h5 text-center font-weight-bold pb-6">
                        Online Admission - Cumulative
                    </v-card-title>
                    <v-skeleton-loader v-if="loading6" type="image" class="mx-auto"
                        style="max-width: 900px; height: 500px;" />
                    <chart v-else ref="chart6"class="chart-line" auto-resize :options="admissionChart" />
                </v-card>
            </template>
        </lazy-observer>

        <!-- <v-container class="mt-6"> -->
        <!-- <v-row justify="center" class="chart-section"> -->

        <!-- 7. Event Utilization -->

        <lazy-observer :onVisible="loadEventData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingEvent" type="image" height="400" />
                <chart v-else-if="event_chart.xAxis.data.length" ref="chart7" class="chart" auto-resize :options="event_chart" />
                <div v-else class="no-data">No Event Data Available.</div>
            </template>
        </lazy-observer>


        <!-- 8. Communication Usage -->

        <lazy-observer :onVisible="loadCommunicationData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingComm" type="image" height="400" />
                <chart v-else-if="communication_chart.xAxis.data.length" ref="chart8" class="chart" auto-resize
                    :options="communication_chart" />
                <div v-else class="no-data">No Communication Data Available.</div>
            </template>
        </lazy-observer>


        <!-- 9. Homework Usage -->

        <lazy-observer :onVisible="loadHomeworkData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingHomework" type="image" height="400" />
                <chart v-else-if="homework_chart.xAxis.data.length" ref="chart9" class="chart" auto-resize
                    :options="homework_chart" />
                <div v-else class="no-data">No Homework Data Available.</div>
            </template>
        </lazy-observer>


        <!-- 10. Maintenance Module -->

        <lazy-observer :onVisible="loadMaintenanceData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingMaint" type="image" height="400" />
                <chart v-else-if="maintenance_chart.xAxis.data.length"  ref="chart10" class="chart" auto-resize
                    :options="maintenance_chart" />
                <div v-else class="no-data">No Maintenance Data Available.</div>
            </template>
        </lazy-observer>


        <!-- 11. Feedback Module -->

        <lazy-observer :onVisible="loadFeedbackData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingFeedback" type="image" height="400" />
                <chart v-else-if="feedback_chart.xAxis.data.length" ref="chart11" class="chart" auto-resize
                    :options="feedback_chart" />
                <div v-else class="no-data">No Feedback Data Available.</div>
            </template>
        </lazy-observer>


        <!-- 12. Visitor Statistics -->

        <lazy-observer :onVisible="loadVisitorData">
            <template v-slot:default>
                <v-skeleton-loader v-if="loadingVisitor" type="image" height="400" />
                <chart v-else-if="visitor_chart.xAxis.data.length" ref="chart12" class="chart" auto-resize :options="visitor_chart" />
                <div v-else class="no-data">No Visitor Data Available.</div>
            </template>
        </lazy-observer>


        <!-- </v-row> -->
        <!-- </v-container> -->
    </div>
</template>

<script>
    import axios from "axios";
    import VChart from "vue-echarts";
    import * as echarts from "echarts";

    export default {
        components: {
            chart: VChart,
            LazyObserver: {
                name: "LazyObserver",
                props: { onVisible: Function },
                data: () => ({ loaded: false, observer: null }),
                mounted() {
                    this.observer = new IntersectionObserver(([e]) => {
                        if (e.isIntersecting && !this.loaded) {
                            this.loaded = true;
                            this.onVisible();
                            this.observer.disconnect();
                        }
                    }, { threshold: 0.1 });
                    this.observer.observe(this.$el);
                },
                beforeDestroy() {
                    this.observer.disconnect();
                },
                render(h) {
                    const slot = this.$slots.default ? this.$slots.default[0] : h("div");
                    return this.loaded ? slot : h("div");
                }
            }
        },
        props: ["selected_ay"],

        data() {
            // const toolbox = {
            //     show: true, orient: "horizontal", right: 20, top: 5,
            //     feature: {
            //         magicType: { show: true, type: ["line", "bar"] },
            //         dataView: { show: true, readOnly: true },
            //         saveAsImage: { show: true },
            //         restore: { show: true }
            //     }
            // };
            return {
                loading1: false,
                loading2: false,
                loading3: false,
                loading4: false,
                loading5: false,
                loading6: false,

                snackbar: false,
                snackbar_msg: "",
                color: "success",

                usageChart: {
                    title: { text: "Current Month Usage Analysis", left: "center", textStyle: { fontSize: 18, fontWeight: "bold" } },
                    tooltip: { trigger: "axis" },
                    grid: { top: 80, bottom: 110, left: 80, right: 80, containLabel: true },
                    xAxis: {
                        type: "category",
                        data: ["Teacher Avg\nWeb Logged-in", "Parent Avg\nWeb Logged-in", "Student Avg\nWeb Logged-in",
                            "Teacher Avg\nApp Logged-in", "Parent Avg\nApp Logged-in", "Student Avg\nApp Logged-in"],
                        axisLabel: { interval: 0, fontSize: 11, formatter: v => v.replace("\\n", "\n") }
                    },
                    yAxis: { type: "value", min: 0, max: 500, interval: 100 },
                    series: [{
                        name: "Unique Users", type: "bar", barWidth: "60%",
                        itemStyle: { color: "#42a5f5" },
                        label: { show: true, position: "top", fontWeight: "bold", fontSize: 14 },
                        data: [0, 0, 0, 0, 0, 0]
                    }]
                },

                sixMonthsChart: {
                    title: { text: "Last Six Months Usage Analysis", left: "center", textStyle: { fontSize: 20, fontWeight: "bold" } },
                    tooltip: { trigger: "axis" },
                    legend: { bottom: 10, textStyle: { fontSize: 12 } },
                    grid: { top: 80, bottom: 100, left: 70, right: 70, containLabel: true },
                    xAxis: { type: "category", data: [], axisLabel: { fontSize: 12 } },
                    yAxis: { type: "value", min: 0, interval: 400, axisLabel: { fontSize: 12 } },
                    series: [
                        { name: "Teacher Avg Web Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#1976d2" }, data: [] },
                        { name: "Parent Avg Web Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#f57c00" }, data: [] },
                        { name: "Student Avg Web Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#616161" }, data: [] },
                        { name: "Teacher Avg App Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#fbc02d" }, data: [] },
                        { name: "Parent Avg App Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#303f9f" }, data: [] },
                        { name: "Student Avg App Logged-In", type: "line", smooth: true, lineStyle: { width: 3 }, itemStyle: { color: "#388e3c" }, data: [] }
                    ]
                },

                moduleChart: {
                    title: { text: "Module Usage Analysis", left: "center", top: 30, textStyle: { fontSize: 20, fontWeight: "bold", color: "#333" } },
                    tooltip: { trigger: "item", formatter: "{b}: {c}<br/>({d}%)" },
                    legend: { orient: "horizontal", bottom: 20, left: "center", data: ["Total Modules", "Current Module Usage"], textStyle: { fontSize: 14 } },
                    series: [{
                        name: "Module Usage",
                        type: "pie",
                        radius: "65%",
                        center: ["50%", "50%"],
                        selectedMode: false,
                        hoverAnimation: false,
                        itemStyle: { borderColor: "#fff", borderWidth: 2 },
                        label: { show: true, position: "inside", color: "#fff", fontSize: 18, fontWeight: "bold", formatter: "{c}" },
                        labelLine: { show: false },
                        data: []
                    }]
                },

                certificateChart: {
                    title: { text: "Certificate Issuance Count", left: "center", top: 20, textStyle: { fontSize: 20, fontWeight: "bold" } },
                    tooltip: { trigger: "axis" },
                    grid: { top: 80, bottom: 80, left: 60, right: 60 },
                    xAxis: { type: "category", data: ["Leaving Certificate", "Bonafide Certificate"], axisLabel: { fontSize: 14, fontWeight: "bold" } },
                    yAxis: { type: "value", min: 0, max: 1000, interval: 100, axisLabel: { fontSize: 12 } },
                    series: [{
                        name: "Issuance Count",
                        type: "bar",
                        barWidth: "40%",
                        itemStyle: { color: "#5470c6" },
                        label: { show: true, position: "top", fontSize: 18, fontWeight: "bold", color: "#000" },
                        data: [0, 0]
                    }]
                },

                cumulativeChart: {
                    title: { text: "Certificate Issuance - Cumulative", left: "center", top: 20, textStyle: { fontSize: 20, fontWeight: "bold" } },
                    tooltip: { trigger: "axis" },
                    legend: { bottom: 10 },
                    grid: { top: 80, bottom: 80, left: 60, right: 60 },
                    xAxis: { type: "category", data: [], axisLabel: { fontSize: 13 } },
                    yAxis: { type: "value", min: 0, max: 1000, interval: 100 },
                    series: [
                        { name: "Leaving Certificate", type: "line", smooth: true, lineStyle: { width: 4, color: "#5470c6" }, itemStyle: { color: "#5470c6" }, areaStyle: { opacity: 0.1 }, data: [] },
                        { name: "Bonafide Certificate", type: "line", smooth: true, lineStyle: { width: 4, color: "#ff7f0e" }, itemStyle: { color: "#ff7f0e" }, areaStyle: { opacity: 0.1 }, data: [] }
                    ]
                },

                admissionChart: {
                    title: { text: "Online Admission - Cumulative", left: "center", top: 20, textStyle: { fontSize: 20, fontWeight: "bold" } },
                    tooltip: { trigger: "axis" },
                    legend: { bottom: 10 },
                    grid: { top: 80, bottom: 80, left: 60, right: 60 },
                    xAxis: { type: "category", data: [], axisLabel: { fontSize: 13 } },
                    yAxis: { type: "value", min: 0, max: 1500, interval: 100 },
                    series: [{
                        name: "Online Admission",
                        type: "line",
                        smooth: true,
                        lineStyle: { width: 5, color: "#1f77b4" },
                        itemStyle: { color: "#1f77b4" },
                        areaStyle: { opacity: 0.2 },
                        symbol: "circle",
                        symbolSize: 10,
                        data: []
                    }]
                },

                loadingEvent: false, loadingComm: false, loadingHomework: false,
                loadingMaint: false, loadingFeedback: false, loadingVisitor: false,

                // Cache object: { "2024-25": { event: {...}, comm: {...} } }
                cache: {},

                // Chart configs (same as yours)
                event_chart: { title: { text: "Parent Slot Booking System Utilization", left: "center" }, color: ["#6BAED6"], tooltip: { trigger: "axis" }, xAxis: { type: "category", data: [], axisLabel: { rotate: 30 } }, grid: { top: 90, bottom: 90 }, yAxis: { type: "value", name: "Bookings" }, series: [{ name: "Bookings", type: "bar", data: [], barWidth: "40%", label: { show: true, position: "top" } }] },

                communication_chart: {
                    title: { text: "Communication Usage", left: "center" },
                    
                    // EXACT pic colors
                    color: ["#74B9FF", "#F9E79F", "#BB8FCE", "#55E6C1"],

                    tooltip: { trigger: "axis" },
                    legend: {
                        bottom: 10,
                        data: ["Notice", "Avg Notice Read", "Album", "Avg Album Read"]
                    },

                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: { rotate: 45 }
                    },

                    grid: {
                        left: "3%",
                        right: "3%",
                        bottom: "5%",
                        containLabel: true
                    },

                    yAxis: {
                        type: "value",
                        name: "Count"
                    },

                    series: [
                        {
                            name: "Notice",
                            type: "bar",
                            barWidth: 7,         // ⭐ SAME AS PIC
                            barGap: "40%",
                            barCategoryGap: "50%",
                            data: [],
                            label: { show: true, position: "top" }

                        },
                        {
                            name: "Avg Notice Read",
                            type: "bar",
                            barWidth: 7,
                            barGap: "40%",
                            barCategoryGap: "50%",
                            data: [],
                            label: { show: true, position: "top" }

                        },
                        {
                            name: "Album",
                            type: "bar",
                            barWidth: 7,
                            barGap: "40%",
                            barCategoryGap: "50%",
                            data: [],
                            label: { show: true, position: "top" }

                        },
                        {
                            name: "Avg Album Read",
                            type: "bar",
                            barWidth: 7,
                            barGap: "40%",
                            barCategoryGap: "50%",
                            data: [],
                            label: { show: true, position: "top" }

                        }
                    ]
                },



                homework_chart: {
                    title: {
                        text: "Homework Usage",
                        left: "center"
                    },
                    // ✔ Two different colors
                    color: ["#A2D9CE", "#F5B041"],

                    // ✔ Show buttons at bottom
                    legend: {
                        bottom: 10,
                        orient: "horizontal"
                    },

                    tooltip: {
                        trigger: "axis"
                    },

                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: { rotate: 45 }
                    },

                    grid: {
                        top: 90,
                        bottom: 90
                    },

                    yAxis: {
                        type: "value",
                        name: "Count"
                    },

                    series: [
                        {
                            name: "Homework",
                            type: "bar",
                            data: [],
                            label: { show: true, position: "top" }
                        },
                        {
                            name: "Average Homework Submission",
                            type: "bar",
                            data: [],
                            label: { show: true, position: "top" }
                        }
                    ]
                },



                maintenance_chart: {
                    title: { text: "Maintenance Module Usage", left: "center" }, color: ["#6BAED6", "#FFA500", "#55E6C1", "#FF6B6B"], tooltip: { trigger: "axis" }, legend: { bottom: 10, data: ["Raised", "In Process", "Resolved", "Rejected"] }, xAxis: { type: "category", data: [], axisLabel: { rotate: 45 } }, grid: { top: 90, bottom: 90 }, yAxis: { type: "value", name: "Tickets" }, series: [
                        { name: "Raised", type: "bar", smooth: true, data: [], label: { show: true, position: "top" } },
                        { name: "In Process", type: "bar", smooth: true, data: [], label: { show: true, position: "top" } },
                        { name: "Resolved", type: "bar", smooth: true, data: [], label: { show: true, position: "top" } },
                        { name: "Rejected", type: "bar", smooth: true, data: [], label: { show: true, position: "top" } }
                    ]
                },

                feedback_chart: {
                    title: {
                        text: "Suggestion / Feedback Module Usage",
                        left: "center"
                    },
                   
                    color: ["#5B8A88"],
                    tooltip: {
                        trigger: "axis"
                    },
                    xAxis: {
                        type: "category",
                        data: [], // will be filled by term names from API
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return value.replace(": ", ":\n");  // multi-line for better readability
                            }
                        },
                        boundaryGap: false
                    },
                    yAxis: {
                        type: "value",
                        name: "Suggestion #"
                    },
                    grid: {
                        top: 90,
                        bottom: 90
                    },
                    series: [{
                        name: "Suggestion #",
                        type: "line",
                        data: [], // filled dynamically
                        label: {
                            show: true,
                            position: "top"
                        },
                        smooth: true,
                        lineStyle: {
                            width: 3
                        }
                    }]
                },

                visitor_chart: {
                    title: { text: "Monthly Visitor Statistics", left: "center" },
                    
                    color: ["#D98C5F"],
                    tooltip: { trigger: "axis" },
                    xAxis: {
                        type: "category",
                        data: [], axisLabel: { rotate: 45 }
                    },
                    grid: { top: 90, bottom: 90 },
                    yAxis: { type: "value", name: "Visitors" },
                    series: [{ name: "Visitors", type: "bar", data: [], label: { show: true, position: "top" } }]
                }

            };

        },

        // Register LazyObserver locally (no global registration needed)
        created() {
            this.$options.components.LazyObserver = {
                name: "LazyObserver",
                props: {
                    onVisible: { type: Function, required: true }
                },
                data: () => ({ loaded: false }),
                mounted() {
                    const observer = new IntersectionObserver(
                        ([entry]) => {
                            if (entry.isIntersecting && !this.loaded) {
                                this.loaded = true;
                                this.onVisible();
                                observer.disconnect();
                            }
                        },
                        { threshold: 0.1 }
                    );
                    observer.observe(this.$el);
                },
                render(h) {
                    return this.loaded
                        ? (this.$slots && this.$slots.default && this.$slots.default[0]) || h("div")
                        : (this.$scopedSlots && this.$scopedSlots.default ? this.$scopedSlots.default() : h("v-skeleton-loader", { props: { type: "image", height: "500px" } }));
                }
            };
        },

        mounted() {
            this.loadCurrentMonth();
            this.registerECharts(); // First chart loads immediately
            window.addEventListener('resize', this.resizeAllCharts);
        },
        beforeDestroy() {
    window.removeEventListener('resize', this.resizeAllCharts);
  },
        computed: {
            ayKey() { return String(this.selected_ay); }
        },
        watch: {
            selected_ay() {
                this.loadCurrentMonth();
                this.cache = {};
                this.clearAllCharts();
                // Other charts will reload when scrolled into view again (because loaded resets on filter change if needed)
            }
        },
        created() {
            // LazyObserver exactly like your AcademicsDashboard
            this.$options.components.LazyObserver = {
                name: "LazyObserver",
                props: { onVisible: Function },
                data: () => ({ loaded: false, observer: null }),
                mounted() {
                    this.observer = new IntersectionObserver(([e]) => {
                        if (e.isIntersecting && !this.loaded) {
                            this.loaded = true;
                            this.onVisible();
                            this.observer.disconnect();
                        }
                    }, { threshold: 0.1 });
                    this.observer.observe(this.$el);
                },
                beforeDestroy() { this.observer.disconnect(); },
                render(h) {
                    const slot = this.$slots.default ? this.$slots.default[0] : h("div");
                    return this.loaded ? slot : h("div");
                }
            };
        },
        methods: {
            resizeAllCharts() {
      this.$nextTick(() => {
        const chartRefs = [
          'chart1', 'chart2', 'chart3', 'chart4', 'chart5', 'chart6',
          'chart7', 'chart8', 'chart9', 'chart10', 'chart11', 'chart12'
        ];

        chartRefs.forEach(refName => {
          const chart = this.$refs[refName];
          if (chart && chart[0] && typeof chart[0].resize === 'function') {
            chart[0].resize();
          }
        });
      });
    },
    triggerDelayedResize() {
      // Multiple delayed calls to catch tab transitions and lazy loading
      setTimeout(() => this.resizeAllCharts(), 100);
      setTimeout(() => this.resizeAllCharts(), 300);
      setTimeout(() => this.resizeAllCharts(), 600);
      setTimeout(() => this.resizeAllCharts(), 1000);
    },
            async loadCurrentMonth() {
                this.loading1 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getCurrentMonthUsageAnalysis", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.login_data) {
                        const d = res.data.login_data;
                        this.usageChart.series[0].data = [
                            d.teacherWeb || 0, d.parentWeb || 0, d.studentWeb || 0,
                            d.teacherApp || 0, d.parentApp || 0, d.studentApp || 0
                        ];
                    }
                } catch (err) { console.error(err); }
                finally { this.loading1 = false; 
                    this.afterLoadResize();
                }
            },

            async loadSixMonths() {
                if (this.loading2) return;
                this.loading2 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getLastSixMonthsUsageAnalysis", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.six_months_data) {
                        const d = res.data.six_months_data;
                        this.sixMonthsChart.xAxis.data = d.labels;
                        this.sixMonthsChart.series[0].data = d.teacher_web;
                        this.sixMonthsChart.series[1].data = d.parent_web;
                        this.sixMonthsChart.series[2].data = d.student_web;
                        this.sixMonthsChart.series[3].data = d.teacher_app;
                        this.sixMonthsChart.series[4].data = d.parent_app;
                        this.sixMonthsChart.series[5].data = d.student_app;
                    }
                } catch (err) { console.error(err); }
                finally { this.loading2 = false;
                    this.afterLoadResize();
                 }
            },

            async loadModuleUsage() {
                if (this.loading3) return;
                this.loading3 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getModuleUsageAnalysis", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.module_data) {
                        const d = res.data.module_data;
                        this.moduleChart.series[0].data = [
                            { value: d.active_modules, name: "Current Module Usage", itemStyle: { color: "#ff7f0e" } },
                            { value: d.total_modules, name: "Total Modules", itemStyle: { color: "#1f77b4" } }
                        ];
                    }
                } catch (err) { console.error(err); }
                finally { this.loading3 = false;
                    this.afterLoadResize();
                 }
            },

            async loadCertificateCount() {
                if (this.loading4) return;
                this.loading4 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getCertificateIssuanceCount", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.certificate_data) {
                        const d = res.data.certificate_data;
                        this.certificateChart.series[0].data = [d.leaving_count || 0, d.bonafide_count || 0];
                    }
                } catch (err) { console.error(err); }
                finally { this.loading4 = false;
                    this.afterLoadResize();
                 }
            },

            async loadCumulativeCertificate() {
                if (this.loading5) return;
                this.loading5 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getCertificateCumulativeCount", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.cumulative_data) {
                        const d = res.data.cumulative_data;
                        this.cumulativeChart.xAxis.data = d.years;
                        this.cumulativeChart.series[0].data = d.leaving_cumulative;
                        this.cumulativeChart.series[1].data = d.bonafide_cumulative;
                    }
                } catch (err) { console.error(err); }
                finally { this.loading5 = false; 
                    this.afterLoadResize();
                }
            },

            async loadOnlineAdmissionCumulative() {
                if (this.loading6) return;
                this.loading6 = true;
                try {
                    const res = await axios.post("/AdminDashboard/getOnlineAdmissionCumulative", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES" && res.data.admission_data) {
                        const d = res.data.admission_data;
                        this.admissionChart.xAxis.data = d.years;
                        this.admissionChart.series[0].data = d.cumulative_admissions;
                    }
                } catch (err) { console.error(err); }
                finally { this.loading6 = false;
                    this.afterLoadResize();
                 }
            },

            registerECharts() { try { VChart.register(echarts); } catch (e) { } },

            clearAllCharts() {
                [this.event_chart, this.communication_chart, this.homework_chart,
                this.maintenance_chart, this.feedback_chart, this.visitor_chart].forEach(c => {
                    c.xAxis.data = [];
                    c.series.forEach(s => s.data = []);
                });
            },

            // Cache helpers
            getCache(key) {
                return this.cache[this.ayKey] ? this.cache[this.ayKey][key] : null;
            },
            setCache(key, data) {
                if (!this.cache[this.ayKey]) this.$set(this.cache, this.ayKey, {});
                this.$set(this.cache[this.ayKey], key, data);
            },

            // ================ Lazy Loaders ================

            async loadEventData() {
                if (this.getCache("event")) { Object.assign(this.event_chart, this.getCache("event")); return; }
                this.loadingEvent = true;
                try {
                    const res = await axios.post("/AdminDashboard/getPTMDetails", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES") {
                        const d = res.data.event_chart_data || [];
                        this.event_chart.xAxis.data = d.map(x => x.event_name || "N/A");
                        this.event_chart.series[0].data = d.map(x => x.total_booking || 0);
                        this.setCache("event", { xAxis: { data: this.event_chart.xAxis.data }, series: [{ data: this.event_chart.series[0].data }] });
                    }
                } catch (e) { this.showSnackbar("error", "Failed to load Event data"); }
                finally { this.loadingEvent = false; 
                    this.afterLoadResize();
                }
            },

            async loadCommunicationData() {
                this.loadingComm = true;

                try {
                    const res = await axios.post(
                        "/AdminDashboard/getCommunicationUsageDeatils",
                        { selected_ay: this.selected_ay }
                    );

                    if (res.data.flag === "YES") {

                        const rawCounts = res.data.communication_chart_data || [];
                        const noticeAvg = res.data.notice_average_read || [];
                        const albumAvg = res.data.album_average_read || [];

                        // monthName -> index map for sorting
                        const monthNameToIndex = {
                            Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
                            Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
                        };

                        const map = {};

                        // --- 1️⃣ Notice / Album Count ---
                        rawCounts.forEach(r => {
                            // server: r.year (number), r.month (like "Jan"), r.type, r.count
                            const year = r.year;
                            const monthName = r.month;
                            const monthIndex = monthNameToIndex[monthName] || 0;
                            const key = `${year}-${String(monthIndex).padStart(2, '0')}`; // e.g. "2025-01"

                            if (!map[key]) {
                                map[key] = {
                                    year,
                                    monthName,
                                    monthIndex,
                                    notice: 0,
                                    noticeAvg: 0,
                                    album: 0,
                                    albumAvg: 0
                                };
                            }

                            if (r.type === "Notice") {
                                map[key].notice = r.count;
                            }

                            if (r.type === "Album") {
                                map[key].album = r.count;
                            }
                        });

                        // --- 2️⃣ Notice Avg Read ---
                        noticeAvg.forEach(r => {
                            const year = r.year;
                            const monthName = r.month;
                            const monthIndex = monthNameToIndex[monthName] || 0;
                            const key = `${year}-${String(monthIndex).padStart(2, '0')}`;

                            if (!map[key]) {
                                map[key] = {
                                    year,
                                    monthName,
                                    monthIndex,
                                    notice: 0,
                                    noticeAvg: 0,
                                    album: 0,
                                    albumAvg: 0
                                };
                            }
                            map[key].noticeAvg = r.avg || 0;
                        });

                        // --- 3️⃣ Album Avg Read ---
                        albumAvg.forEach(r => {
                            const year = r.year;
                            const monthName = r.month;
                            const monthIndex = monthNameToIndex[monthName] || 0;
                            const key = `${year}-${String(monthIndex).padStart(2, '0')}`;

                            if (!map[key]) {
                                map[key] = {
                                    year,
                                    monthName,
                                    monthIndex,
                                    notice: 0,
                                    noticeAvg: 0,
                                    album: 0,
                                    albumAvg: 0
                                };
                            }
                            map[key].albumAvg = r.avg || 0;
                        });

                        // Build sorted array of keys by year then monthIndex
                        const sortedEntries = Object.values(map).sort((a, b) => {
                            if (a.year !== b.year) return a.year - b.year;
                            return a.monthIndex - b.monthIndex;
                        });

                        // xAxis labels: choose format you prefer. Here "Jan 2025"
                        const months = sortedEntries.map(e => `${e.monthName} ${e.year}`);

                        // Set chart data
                        this.communication_chart.xAxis.data = months;
                        this.communication_chart.series[0].data = sortedEntries.map(e => e.notice);
                        this.communication_chart.series[1].data = sortedEntries.map(e => e.noticeAvg);
                        this.communication_chart.series[2].data = sortedEntries.map(e => e.album);
                        this.communication_chart.series[3].data = sortedEntries.map(e => e.albumAvg);
                    }

                } catch (e) {
                    this.showSnackbar("error", "Failed to load Communication data");
                }

                this.loadingComm = false;
                this.afterLoadResize();
            },



            async loadHomeworkData() {
                if (this.getCache("hw")) {
                    Object.assign(this.homework_chart, this.getCache("hw"));
                    return;
                }

                this.loadingHomework = true;

                try {
                    const res = await axios.post("/AdminDashboard/getHomeworkDetails", {
                        selected_ay: this.selected_ay
                    });

                    if (res.data.flag === "YES") {

                        const raw = res.data.homework_chart_data || [];

                        // Month name → index map
                        const monthNameToIndex = {
                            Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
                            Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
                        };

                        let map = {};

                        // 1️⃣ Homework Count
                        raw.forEach(r => {
                            const year = r.year;
                            const monthName = r.month;
                            const monthIndex = monthNameToIndex[monthName] || 0;

                            const key = `${year}-${String(monthIndex).padStart(2, '0')}`;

                            if (!map[key]) {
                                map[key] = {
                                    year,
                                    monthName,
                                    monthIndex,
                                    count: 0
                                };
                            }

                            map[key].count += r.homework_count;
                        });

                        // 2️⃣ Avg Submission
                        const avgRaw = res.data.average_submission_per_homework || [];
                        let avgMap = {};

                        avgRaw.forEach(r => {
                            const year = r.year;
                            const monthName = r.month;
                            const monthIndex = monthNameToIndex[monthName] || 0;

                            const key = `${year}-${String(monthIndex).padStart(2, '0')}`;

                            if (!avgMap[key]) avgMap[key] = 0;
                            avgMap[key] += r.avg || 0;

                            if (map[key]) {
                                map[key].avg = avgMap[key];
                            }
                        });

                        // Ensure avg exists
                        Object.keys(map).forEach(k => {
                            if (!map[k].avg) map[k].avg = 0;
                        });

                        // 3️⃣ Sort by year → monthIndex
                        const sortedEntries = Object.values(map).sort((a, b) => {
                            if (a.year !== b.year) return a.year - b.year;
                            return a.monthIndex - b.monthIndex;
                        });

                        // X-axis labels like "Jan 2025"
                        const months = sortedEntries.map(e => `${e.monthName} ${e.year}`);

                        // Set chart data
                        this.homework_chart.xAxis.data = months;
                        this.homework_chart.series[0].data = sortedEntries.map(e => e.count);

                        // Add avg series if not exists
                        if (!this.homework_chart.series[1]) {
                            this.homework_chart.series.push({
                                name: "Avg Submission",
                                type: "line",
                                data: []
                            });
                        }

                        this.homework_chart.series[1].data = sortedEntries.map(e => e.avg);

                        this.setCache("hw", JSON.parse(JSON.stringify(this.homework_chart)));
                    }

                } catch (e) {
                    this.showSnackbar("error", "Failed to load Homework data");
                } finally {
                    this.loadingHomework = false;
                    this.afterLoadResize();
                }
            },



            async loadMaintenanceData() {
                if (this.getCache("maint")) {
                    Object.assign(this.maintenance_chart, this.getCache("maint"));
                    return;
                }
                this.loadingMaint = true;
                try {
                    const res = await axios.post("/AdminDashboard/getMaintenanceStatusDetails", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES") {
                        const raw = res.data.maintenance_chart_data || [];
                        const map = {};
                        raw.forEach(r => {
                            const k = `${r.year}-${r.month}`;
                            map[k] = {
                                raised: (r.cancelled || 0) + (r.inprocess || 0) + (r.rejected || 0) + (r.completed || 0), // or any logic you want for "raised"
                                inProcess: r.inprocess || 0,
                                resolved: r.completed || 0,
                                rejected: r.rejected || 0
                            };
                        });

                        const months = Object.keys(map).sort();
                        this.maintenance_chart.xAxis.data = months;
                        this.maintenance_chart.series[0].data = months.map(m => map[m].raised);
                        this.maintenance_chart.series[1].data = months.map(m => map[m].inProcess);
                        this.maintenance_chart.series[2].data = months.map(m => map[m].resolved);
                        this.maintenance_chart.series[3].data = months.map(m => map[m].rejected);

                        this.setCache("maint", JSON.parse(JSON.stringify(this.maintenance_chart)));
                    }
                } catch (e) {
                    this.showSnackbar("error", "Failed to load Maintenance data");
                } finally {
                    this.loadingMaint = false;
                    this.afterLoadResize();
                }
            },

            async loadFeedbackData() {
                if (this.getCache("feedback")) {
                    Object.assign(this.feedback_chart, this.getCache("feedback"));
                    return;
                }
                this.loadingFeedback = true;
                try {
                    const res = await axios.post("/AdminDashboard/getSuggestionDetails", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES") {
                        const termData = res.data.feedback_termwise_data || [];
                        this.feedback_chart.xAxis.data = termData.map(x => x.term);
                        this.feedback_chart.series[0].data = termData.map(x => x.total_feedback);
                        this.setCache("feedback", JSON.parse(JSON.stringify(this.feedback_chart)));
                    }
                } catch (e) {
                    this.showSnackbar("error", "Failed to load Feedback data");
                } finally {
                    this.loadingFeedback = false;
                    this.afterLoadResize();
                }
            },


            async loadVisitorData() {
                if (this.getCache("visitor")) { Object.assign(this.visitor_chart, this.getCache("visitor")); return; }
                this.loadingVisitor = true;
                try {
                    const res = await axios.post("/AdminDashboard/getVisitorVisitsDetails", { selected_ay: this.selected_ay });
                    if (res.data.flag === "YES") {
                        const raw = res.data.visitor_chart_data || [];
                        const map = {}; raw.forEach(r => { const k = `${r.year}-${r.month}`; map[k] = (map[k] || 0) + r.total_visitors; });
                        const months = Object.keys(map).sort();
                        this.visitor_chart.xAxis.data = months;
                        this.visitor_chart.series[0].data = months.map(m => map[m]);
                        this.setCache("visitor", JSON.parse(JSON.stringify(this.visitor_chart)));
                    }
                } catch (e) { this.showSnackbar("error", "Failed to load Visitor data"); }
                finally { this.loadingVisitor = false;
                    this.afterLoadResize();
                 }
            }


        }
    };
</script>

<style scoped>
    .dashboard-container {
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 60px;
    }

    .no-data {
        text-align: center;
        color: #777;
        font-size: 1.1rem;
        padding: 60px 0;
    }

    .chart {
        height: 520px;
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;
    }

    .chart-pie {
        height: 500px;
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
    }

    .chart-bar {
        height: 520px;
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
    }

    .chart-line {
        height: 520px;
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;
    }
</style>